import React, { useState, useEffect  } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import { connect } from 'react-redux';
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { goToPage, setSelectedPackage, reportDWH, setOrderType, setSaleType } from '../saleJetBlockSlice';
import SalePackages from '../../SalePackagesBlock/SalePackages';
import { prepareSaleAsync, goToNextPage, prepareSaleReplaceAsync, getOrgBenefitsAllocations, createWorkOrder } from '../saleBlockAsyncThunk';
import { trackCustom } from 'react-facebook-pixel';
import { gtag4, switchExtraction } from '../../../../utilities/analytics/tracking';
import { OrgEmployeeLoginTypes } from '../../OTPLoginBlock/Assets/variables';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';
import { isOrgEmployeeLogin } from '../../OTPLoginBlock/Assets/variables';
import { setMessageData } from '../../../Page/OrgEmployeeFamilySalePage/OrgEmployeeFamilySaleSlice';
import {messageData} from '../../../Page/OrganizationEmloyeePage/Conatant';
const PackagesPage = (props) => {
  
  const isOrgEmployee = isOrgEmployeeLogin(props._authentication);
  const [packages, setPackages] = useState(props.salePackages);
  useEffect(() => {
    props.reportDWH({ actionType: 'Select Offer', status: 'Ongoing', messageText: 'Offer Page Displayed' });
    if(props.isStartFromAddressPage){
      gtag4({
        event: `${props.saleType}_Step1_PackagesPageImp`,
        step: '1',
        action: "PackagesPage" ,
        funnel_name:  "Address_Check" ,
      });
    }

  }, []);

  useEffect(() => {
    if(isOrgEmployee){
      setPackages({ expandedValue: [] });
      getOrgBenefitsAllocationsAsync();
    }
  }, [isOrgEmployee]);

  

  const getOrgBenefitsAllocationsAsync = async () => {
    var productsDescription = props?.productsDescription || {};
    const salesPackages = await props.getOrgBenefitsAllocations({productsDescription, saleType: props.saleType});
    if(!isNullOrEmpty(salesPackages?.payload)){
      setPackages({ expandedValue: salesPackages?.payload });
      }else{
        setPackages(props.salePackages);
      }
  }

  //page params
  let isDisplayFooter = false;
  let btnText = 'המשך';
  let currentPageFunction = null;
  let totalPrice = null;
  let priceText = '';
  let formid = 'saleJet';
  //page params

  let title = '';
  let subTitle = '';

  if (props.saleType == 'tv' || props.saleType == 'app') {
    title = `מצטרפים ל${window.Config.brand_Name_HE} TV`;
    subTitle = 'ונהנים מצפייה ב4K בתכנים הטובים בעולם!';
  } else if (props.saleType == 'triple') {
    title = `מצטרפים ל${window.Config.brand_Name_HE} FiberTV`;
    subTitle = 'חווית גלישה וצפיה ברמה אחרת';
  } else if (props.saleType == 'cellular') {
    title = 'חבילות הסלולר המובילות שלנו';
    subTitle = '';
  } else if (props.saleType == 'landline') {
    title = 'בחרו חבילת קווי';
    subTitle = 'אינטרנט, טלוויזיה או שלשות — מה שמתאים לכם';
  } else {
    title = `מצטרפים ל${window.Config.brand_Name_HE} פייבר`;
    subTitle = 'סיבים אופטיים במגוון חבילות לאינטרנט עוצמתי בבית';
  }
  let epiTitle = props.iContent?.title?.value;
  let epiSubTitle = props.iContent?.subTitle?.value;
  if(epiTitle){
    title = epiTitle;
  }
  if(epiSubTitle){
    subTitle = epiSubTitle;
  }
  if (props.isStartFromAddressPage) {
    title = 'עם איזו חבילה נמשיך?';
    subTitle = '';
  }

  if (props.orderType == 'replace') {
    title = (
      <>
        ראינו שבחרת בחבילת {props.offerName}
        <br /> ורצינו להציע לך חבילה שמתאימה לך יותר
      </>
    );
    subTitle = '';
  }

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'></h1>
      <h1 className='sale-title-big'> {title} </h1>
      <h2 className='sale-title-small'> {subTitle} </h2>
      {props.orderType == 'replace' && (
        <div className='sale-bottom-link'>
          <a href='#' onClick={() => handleSkipThisPage()}>
            רוצה להשאר עם בחירת החבילה שעשיתי
          </a> n
        </div>
      )}
    </div>
  );

  const hasInternet = props.userAddressForUpgradePage.selectedAddress?.products?.find(x => x.type.toLowerCase() == 'internet');

  let currentPageView = (
    <SalePackages
      packages={packages}
      orderType={props.orderType}
      onSelectedPackages={onSelectedPackages}
      isRouterPopupDisabled={!!hasInternet}
      HasXgsponOnAddress={props.technologyType == 'XGSPON'}
    />
  );

 const renderExistingCustomerText= () => {
     
  const openNewCustomerPopup = async () => {
      var result = await props.createWorkOrder({
        orderType: 'SALE_NEW_CUSTOMER',
        saleType: props.saleType,
      });
      if(result?.payload?.isSuccess){
        props.setMessageData(messageData.newCustomerPopup);
      }else{
        props.setMessageData(messageData.newCustomerCreateWorkOrderFailed);
      }
   };

      if(isOrgEmployee){
      return (
        <div className='existing-customer-text-wrapper'>
          <p className='title'> כבר לקוחות סלקום ורוצים לעדכן את החבילה הקיימת שלכם?</p>
          <p className='action-text' onClick={openNewCustomerPopup} >לחצו כאן ונחזור אליכם</p>
        </div>
      );
    }
    return null;
 }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content full-width'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          priceText={priceText}
          formid={formid}
        />
      </div>
      {renderExistingCustomerText()}
    </div>
  );

  function onSelectedPackages(salePackage) {
    const selectedPackage = {
      ...salePackage,
    };
    props.setSelectedPackage(selectedPackage);

    if (props.orderType == 'replace') {
      props.setSaleType(selectedPackage.saleType);
      //update address from userAddressPage
      props.prepareSaleReplaceAsync();
      return;
    }

    // landline hub: resolve to the package product saleType and reuse that funnel
    const resolvedSaleType =
      props.saleType === 'landline' ? selectedPackage.saleType : props.saleType;
    if (props.saleType === 'landline') {
      props.setSaleType(resolvedSaleType);
    }

    props.reportDWH({ actionType: 'Select Offer', status: 'Ongoing', messageText: 'Offer Button Clicked' });

    if (resolvedSaleType == 'tv' || resolvedSaleType == 'app' || resolvedSaleType == 'cellular') {
      if (props._authentication.loginData.isFullAuthenticated) {
        props.prepareSaleAsync();
      } else {
        props.goToPage('loginPage');
      }
    } else {
      const hasSelectedAddress = props.selectedAddress && Object.keys(props.selectedAddress).length > 0;
      if (hasSelectedAddress) {
        if (resolvedSaleType === 'internet' || props._authentication.loginData.isFullAuthenticated) {
          props.prepareSaleAsync();
        } else {
          props.goToPage('loginPage');
        }
      } else {
        props.goToPage('addressPage');
      }
    }
    gtag4({
      event: `${resolvedSaleType}_Step1_PackageClick`,
      step: '2',
      package: switchExtraction(salePackage.title),
      badge: salePackage.benefitTitle,
      button: salePackage.buttonText,
      action: props.isStartFromAddressPage ? "PackagesPage" : "PackagesPageImp",
      funnel_name: props.isStartFromAddressPage ? "Address_Check" : "Choose_Package",
    });
  }

  function handleSkipThisPage() {
    props.setOrderType('provide');
    props.goToNextPage();
  }

  function handleSubmit(event) {
    event.preventDefault();
  }
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    orderType: state.saleJetBlock.orderType,
    flowType: state.saleJetBlock.flowType,
    offerName: state.saleJetBlock.offerName,
    salePackages: state.saleJetBlock.saleBlockData.salePackages,
    selectedAddress: state.saleJetBlock.addressPage.selectedAddress,
    userAddressForUpgradePage: state.saleJetBlock.userAddressForUpgradePage,
    technologyType: state.saleJetBlock.addressPage.selectedEntry?.technologyType,
    isStartFromAddressPage: state.saleJetBlock.saleBlockData.isStartFromAddressPage,
    productsDescription: state.orgEmployeeFamilySale?.benefitsAllocations,

    //other states
    _authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  goToPage,
  setSelectedPackage,
  reportDWH,
  prepareSaleAsync,
  goToNextPage,
  setOrderType,
  setSaleType,
  prepareSaleReplaceAsync,
  getOrgBenefitsAllocations,
  setMessageData,
  createWorkOrder,
};

export default connect(mapStateToProps, mapDispatchToProps)(PackagesPage);
